import React, { FormEvent, SetStateAction, useCallback, useEffect, useState } from 'react'
import { useVacancy } from '../../../../Hooks/getVacancy'
import axios from 'axios';
import { BASE_URL_ADDR } from '../../../../Constants/BaseURL';
import { useNavigate, useParams } from 'react-router-dom';
import { RegisterHeader } from '../../Components/Index';
import psc from '../../../../Assets/images/psc_logo.png';
import police from '../../../../Assets/images/logo.png';
import nig_logo from '../../../../Assets/images/ng_flag_logo.png';
import Footer from '../../../../Layout/Footer';
import toast, { Toaster } from 'react-hot-toast';
import CloudAssert from '../../../../Hooks/loadAssert';
import { message } from 'antd';
import applicantsService from '../../../../Services/applicantsService';
// import { time } from 'console';

export default function DocumentManager () {
  const { nin } = useParams<{nin:string}>()
  const { jobVacancyJsonz } = useVacancy()
  const [refInput, setRefInput] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<any>();
  const [applicationResults, setApplicationResults] = useState<any>();
  const [workFlow, setWorkFlow] = useState<any>()
  // const [requiredDox, setRequiredDox] = useState<string[]>([''])
  // const [availableDox, setAvailableDox] = useState<any>()
  // const [comparisonOutp, setComparisonOut] = useState<boolean>(true)
  const navigate = useNavigate();
  const [missingDox, setMissionDox] = useState<string[]>([''])
  const [filePreviews, setFilePreviews] = useState<any>({});
  const [fileFIle, setFileFile] = useState<any>({});
  const [formData, setFormData] = useState<any>({
    state: '',
    lga: ''
  });
  const onSubmit = (e: FormEvent) => {
    e.preventDefault();
    preview();
  }

  const changeFormData = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData((prev: any) => {
      const newData = { ...prev, [name]: value };
      if (name === 'state') {
        newData.lga = '';
      }
      return newData;
    });
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>, docName: string) => {
    const file = e.target.files?.[0];
    if (file) {
      setFileFile((prev: any) => ({ ...prev, [docName]: file }));
      const reader = new FileReader();
      reader.onloadend = () => {
        setFilePreviews((prev: any) => ({ ...prev, [docName]: reader.result as string }));
      };
      reader.readAsDataURL(file);
    }
  };
  const { loadAssert } = CloudAssert();
  const submitDocuments = async () => {
  // --- VALIDATION ---
    if ((applicationResults?.stateOfPermanent === '' && formData.state === '') || (applicationResults?.lgaOfPermanent === '' && formData.lga === '')) {
      toast.error("Please provide your State and LGA of Permanent Residence before submitting.");
      return;
    }

    if (missingDox.length > 0 && Object.keys(filePreviews).length === 0) {
      toast.error("Please select documents to upload.");
      return;
    }

    setLoading(true);

    try {
      if (formData.state !== '' || formData.lga !== '') {
        const payloadData = {
          nin: applicationResults?.nin || refInput,
          formData,
        };

        // We use JSON here because it's just text data
        const res = await axios.post(
        `${BASE_URL_ADDR}/recruitment/candidate-profile-update`,
        payloadData,
        {
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          timeout: 120000
        }
        );

        if (res.status !== 200) {
          throw new Error('Profile update failed');
        }
      }

      // console.log('FILE UPLOAD START', fileFIle);
      const docKeys = Object.keys(fileFIle);

      for (const docName of docKeys) {
        const currentFileData = fileFIle[docName];
        console.log(`UPLOADING ${docName}:`, currentFileData);

        // Create FormData to send BINARY file
        const formDataPayload = new FormData();
        formDataPayload.append('nin', applicationResults?.nin || refInput);
        formDataPayload.append('profileFetchMode', '1');
        formDataPayload.append('documentType', docName === 'profession-certificate' ? 'professionalCertificate' : docName);
        formDataPayload.append('workFlow', 'formSubmission');
        // Append the actual file object
        formDataPayload.append('document', currentFileData);

        const res = await axios.post(
        `${BASE_URL_ADDR}/recruitment/receive-upload-credentials`,
        formDataPayload,
        {
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        }
        );

        if (res.status !== 200) {
          setLoading(false);
          throw new Error(`Failed to upload ${docName}`);
        }
      }

      // console.log("All steps complete. Syncing...");

      await applicantsService.crsync(Number(refInput || nin));

      message.success({
        content: 'Submission successful',
        style: { zIndex: '200000' },
      });

      toast.success("Documents and Information submitted successfully!");

      // Clear state and navigate
      setFilePreviews({});
      setFileFile({});
      setLoading(false);
      navigate(`/print-slip/${refInput || nin}`);
    } catch (error) {
      console.error("Submission Error:", error);
      setLoading(false);
      toast.error("Failed to submit documents. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  const preview = async () => {
    setLoading(true);

    axios({
      method: 'GET',
      url: `${BASE_URL_ADDR}/recruitment/print-slip?nin=${refInput || nin}`,
      headers: {
        'content-type': 'application/json',
        Accept: 'application/json',
      },
    }).then(async response => {
      const data = response.data;
      // console.log("data", data);
      //   setQRCode(data.authQR)
      //   setNimcRecord(data.dataset.nimc)
      setApplicationResults({ photo: data.photo, ...data.dataset.formData });
      setWorkFlow(data.dataset.workflow)
      //   setApplicationPayment(data.metadata);
      setLoading(false);
    }).catch(error => {
      console.log("data", error);
      setError(error?.response?.data?.message || "Application does no exist!");
      setLoading(false);
    }).finally(() => {
      setLoading(false);
    })
  }
  const changeRef = useCallback((e: { target: { value: SetStateAction<string>; }; }): void => {
    setRefInput(e.target.value);
  }, [setRefInput]);

  const remarkChecker = () => {
    const roleType = applicationResults.candidateRole
    const workFlowManifest = workFlow.formSubmission.manifest
    const documentType = jobVacancyJsonz.dataset.categoryAttribute.filter((document: any) => roleType in document)

    const requiredDocs = documentType[0][roleType].documentUpload
    const manifestDocs = Object.keys(workFlowManifest)
    const setJsonRecord = new Set(manifestDocs)
    const expectType = requiredDocs.filter((doc: string) => !setJsonRecord.has(doc))
    // console.log('MAnifestINFO:', expectType)
    // console.log('SET')
    // const output = requiredDocs.every((key: any) => setJsonRecord.has(key))
    // console.log('RequiredDocs:', output)
    // setRequiredDox(requiredDocs)
    setMissionDox(expectType)
    // setAvailableDox(setJsonRecord)
    // setComparisonOut(output)
  }
  // const checkIfTrue = (currentDocx: string) => {
  //   return availableDox?.has(currentDocx);
  // }
  // console.log('MISSING DOX:', applicationResults)
  const formatText = (text: string) => {
    if (!text) return "";
    if (text === 'lgaCertificate') {
      return 'LGA Certificate'
    }
    if (text === 'ssce') {
      return text.toUpperCase()
    }
    return text
    // 1. Replace hyphens with spaces
      .replace(/-/g, ' ')
    // 2. Insert space before capital letters (e.g., "candidateRole" -> "candidate Role")
      .replace(/([a-z])([A-Z])/g, '$1 $2')
    // 3. Capitalize the first letter of each word
      .replace(/\b\w/g, char => char.toUpperCase());
  };

  useEffect(() => {
    if (nin) {
      setRefInput(nin);
    }
  }, [nin]);

  useEffect(() => {
    if (refInput) {
      preview();
    }
  }, [refInput]);

  useEffect(() => {
    if (applicationResults && applicationResults.candidateRole) {
      remarkChecker()
    }
  }, [applicationResults])
  return (
    <>
       <RegisterHeader />
      <main role="main" className="container print--slip pt-5">
{
          (!applicationResults) &&
          // Added 'd-flex align-items-center' to center the card vertically on screen
          <section className="print--slip-form container d-flex align-items-center justify-content-center" style={{ minHeight: '60vh' }}>

            {/* Card: Added 'shadow-lg' for depth and removed the default border */}
            <div className="card border-0 shadow-lg rounded-3 my-5" style={{ width: '100%', maxWidth: '550px' }}>

              {/* Header: Removed 'section-header-bg'. Changed to white bg with green text for a cleaner look */}
              <div className="card-header bg-white border-0 text-center pt-4 pb-0">
                <h5 className="text-success font-weight-bold" style={{ fontSize: '1.25rem' }}>
                Update Your Documents
               </h5>
              </div>

              <div className="card-body p-5 row">
                {/* Changed w-5 to w-100 to ensure it fits the container properly */}
                <div className="col-12 text-center">
                  <form onSubmit={onSubmit}>
                    {
                      !nin &&
                      <div className="form-group text-left mb-4">
                        <label htmlFor="refid" className="text-muted font-weight-bold ml-1" style={{ fontSize: '0.9rem' }}>
                          Enter your NIN
                        </label>
                        {/* Input: Added padding (p-3) and light background */}
                        <input
                          onChange={changeRef}
                          value={refInput}
                          type="text"
                          id="refid"
                          placeholder="e.g. 123456789"
                          className="form-control form-control-lg bg-light border-0"
                          style={{ borderRadius: '10px' }}
                          disabled={loading}
                        />
                        <p className="error-value mt-2 small" style={{ color: '#dc3545' }}>{error}</p>
                      </div>
                    }
                    {/* Button: Changed text-dark to text-white. Added padding and bold text */}
                    <button
                      disabled={loading}
                      className="btn btn-success text-white shadow-sm btn-block py-3 font-weight-bold"
                      style={{ borderRadius: '10px', fontSize: '1rem', letterSpacing: '0.5px' }}
                      type="submit"
                    >
                      Preview
                      {loading && <div style={{ marginLeft: 10 }} className="spinner-border spinner-border-sm"></div>}
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </section>
        }
        {applicationResults && <>
        <section className="my-5">
            <div className="container">
              <div className="pb-5 mt-4 mb-3 bg-white shadow">
                <div className=" bg-primary rounded-top">
                  <div className=" w-100 float-left p-4 border-0 section-header-bg">
                    <div className="row h-100">
                      <div className="col-sm-3 my-auto text-center d-block d-lg-none">
                              <div className='d-flex px-5 position-relative v-w'>
          <div className='logo-style'>
            <img src={psc} width={60} height={60} className='rounded-pill' />
            <img src={police} width={60} height={60} className='rounded-pill' />
          </div>
          <div>
            <img
              src={nig_logo}
              width={150}
              height={150}
              className='rounded-pill ms-3'
            />
          </div>
        </div>
                      </div>
                                            <div className="col-sm-3 my-auto text-center d-none d-lg-block">

                        <img className="img-responsive border border-white rounded" width='120' height='120' src={`${applicationResults.photo || ''}`} />
                      </div>

                      <div className="col-sm-6 my-auto text-center">
                        <h2 className='text-light'> <strong>2025 Nigeria Police Force Recruitment</strong></h2>
                        <h2 className='text-light'>Application Document Manager</h2>
                        <h4 className='text-light fw-bold py-4'>{(applicationResults?.surname || applicationResults?.surName)?.slice(0, 1).toUpperCase() + (applicationResults?.surname || applicationResults?.surName)?.slice(1).toLowerCase() || ''} {(applicationResults?.middlename || applicationResults?.middleName)?.slice(0, 1).toUpperCase() + (applicationResults?.middlename || applicationResults?.middleName)?.slice(1).toLowerCase() || ''}  {(applicationResults?.firstname || applicationResults?.firstName)?.slice(0, 1).toUpperCase() + (applicationResults?.firstname || applicationResults?.firstName)?.slice(1).toLowerCase() || ''}</h4>
                        <h6 className='text-light fw-bold'>NIN: {applicationResults?.nin}</h6>
                       {/* {(applicationPayment.isQualified !== 0 && applicationResults?.referenceNo) && (<h6 className='text-light fw-bold'>Reference Number: {applicationResults?.referenceNo}</h6>)} */}
                      </div>
                          <div className="col-sm-3 my-auto text-center d-block d-lg-none">

                        <img className="img-responsive border border-white rounded" width='120' height='120' src={`${applicationResults.photo || ''}`} />
                      </div>
<div className="col-sm-3 my-auto text-center d-none d-lg-block">
                              <div className='d-flex px-5 position-relative v-w'>
          <div className='logo-style'>
            <img src={psc} width={60} height={60} className='rounded-pill' />
            <img src={police} width={60} height={60} className='rounded-pill' />
          </div>
          <div>
            <img
              src={nig_logo}
              width={150}
              height={150}
              className='rounded-pill ms-3'
            />
          </div>
        </div>
                      </div>

                    </div>
                  </div>
                </div>
         <div className='container py-5'>
             <div className="row justify-content-center">
                 <div className="col-12 text-center mb-4 mt-4">
                     <h3 className="text-primary fw-bold">Upload Missing Documents {(applicationResults?.lgaOfPermanent !== '' || applicationResults?.stateOfPermanent !== '') && '/ Informations'}</h3>
                     <p className="text-muted">Please provide clear scanned copies of the documents listed below  {(applicationResults?.lgaOfPermanent === '' || applicationResults?.stateOfPermanent === '') && 'and ensure you correctly fill the missing informations'} .</p>
                 </div>
                  {(applicationResults?.lgaOfPermanent === '' || applicationResults?.stateOfPermanent === '') && <div className="row col-12 justify-content-center mb-4">
                   <div className="col-md-10 col-lg-8">
                     <div className="card border-0 shadow-sm" style={{ backgroundColor: '#f8f9fa' }}>
                       <div className="card-body p-4">
                         <div className="row">
                          {applicationResults?.stateOfPermanent === '' && <div className="col-md-6">
                             <label className="form-label fw-bold text-muted small text-uppercase">State of Permanent Residence</label>
                             <select
                              className='form-control custom-form-control'
                              id='stateOfPermanent'
                              name='state'
                              onChange={changeFormData}
                            >
                              <option value=''>Select state</option>
                              {loadAssert.states &&
                                loadAssert?.states.map(
                                  (state: any, index: number) => (
                                    <option key={index} value={state.name}>
                                      {state.name}
                                    </option>
                                  )
                                )}
                            </select>
                           </div>}
                              {applicationResults?.stateOfPermanent === '' && <div className="col-md-6 mb-3 mb-md-0">
                             <label className="form-label fw-bold text-muted small text-uppercase">LGA of Permanent Residence</label>
                              <select
                              className='form-control custom-form-control'
                              // disabled
                              id='lgaOfPermanent'
                              name='lga'
                              onChange={changeFormData}
                            >
                              <option value=''>Select LGA</option>
                              {formData.state &&
                                loadAssert.lgas[2]?.data
                                  ?.filter(
                                    (y: { state_id: any }) =>
                                      String(y.state_id) ===
                                      String(loadAssert.states.find(
                                        (x: any) =>
                                          x?.name ===
                                          formData.state
                                      )?.id)
                                  )
                                  .map((lga: any, index: number) => (
                                    <option key={index} value={lga.name}>
                                      {lga.name}
                                    </option>
                                  ))}
                            </select>
                           </div>}
                         </div>
                       </div>
                     </div>
                   </div>
                 </div>}
                 {
                     missingDox.map((doc: string, index: number) => (
                         <div className="col-md-6 col-lg-4 mb-4" key={index}>
                             <div className="card h-100 border-0 shadow-sm" style={{ backgroundColor: '#f8f9fa' }}>
                                 <div className="card-body p-4 text-center">
                                     <div className="mb-3" style={{ height: '100px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                         {filePreviews[doc] && (
                                             <img src={filePreviews[doc]} alt="Preview" style={{ maxHeight: '100%', maxWidth: '100%', objectFit: 'contain' }} className="rounded shadow-sm border" />
                                         )}
                                         {!filePreviews[doc] && (
                                             <i className="ri-image-add-line text-muted" style={{ fontSize: '3rem', opacity: 0.3 }}></i>
                                         )}
                                     </div>
                                     <label className="form-label fw-bold text-dark mb-3 d-block text-capitalize" htmlFor={`file_${index}`} style={{ fontSize: '1.05rem' }}>
                                         {formatText(doc)}
                                     </label>
                                     <div className="input-group">
                                         <input
                                             type="file"
                                             className="form-control"
                                             accept="image/jpeg"
                                             id={`file_${index}`}
                                             name={doc}
                                             onChange={(e) => handleFileChange(e, doc)}
                                         />
                                     </div>
                                     <div className="form-text text-muted mt-2 small">
                                         Max size: 2MB | JPG format only
                                     </div>
                                 </div>
                             </div>
                         </div>
                     ))
                 }
                 <div className="col-12 text-center mt-4">
                     <button
                        className="btn btn-primary btn-lg px-5 py-3 shadow-sm rounded-pill fw-bold"
                        onClick={submitDocuments}
                        disabled={loading}
                     >
                         {loading && (
                             <>
                                 <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                 Uploading...
                             </>
                         )}
                         {!loading && (
                             <>
                                <i className="ri-save-line me-2"></i> Submit Documents
                             </>
                         )}
                     </button>
                 </div>
             </div>
        </div>
        </div>
        </div>
        </section>
        </>
        }
        </main>
        <Toaster />
             <Footer />
    </>
  )
}
